/* eslint-disable security/detect-object-injection */

import './ActionField.style.less'

import ActionFieldButton from './components/ActionFieldButton/ActionFieldButton'
import { Button, Row } from 'antd'
import { get } from 'lodash'

interface Prop {
  type: string
  current_status: string // ex: Started
  value: any
  onSubmit?: (value: any) => void
  isLoading?: boolean
  isUserssignedAndIsUpdater: boolean
}

export function ActionField(props: Prop) {
  const {
    current_status,
    type,
    value,
    isLoading = false,
    onSubmit,
    isUserssignedAndIsUpdater,
  } = props

  const SubmitComponent = (
    <Button
      type="primary"
      size="middle"
      htmlType="submit"
      className="bg-primary"
      loading={isLoading}
      onClick={() => onSubmit('submitted')}
    >
      Submit
    </Button>
  )

  const RejectApproveComponent = !isUserssignedAndIsUpdater && (
    <>
      <ActionFieldButton
        onClicked={() => onSubmit('rejected')}
        className="button-reject"
        label="Reject"
      />
      <ActionFieldButton
        onClicked={() => onSubmit('approved')}
        className="bg-approve"
        label="Approve"
      />
    </>
  )
  const InProgressDoneComponent = (
    <>
      <ActionFieldButton
        onClicked={() => onSubmit('in_progress')}
        className="bg-primary"
        label="In Progress"
      />
      <ActionFieldButton
        onClicked={() => onSubmit('done')}
        className="bg-approve"
        label="Done"
      />
    </>
  )

  const DoneComponent = (
    <ActionFieldButton
      onClicked={() => onSubmit('done')}
      className="bg-approve"
      label="Done"
    />
  )

  const PassFailComponent = (
    <>
      <ActionFieldButton
        className="button-reject"
        label="Fail"
        onClicked={() => onSubmit('fail')}
      />
      <ActionFieldButton
        onClicked={() => onSubmit('pass')}
        className="bg-approve"
        label="Pass"
      />
    </>
  )

  const SaveComponent = (
    <ActionFieldButton
      onClicked={() => onSubmit('save')}
      className="bg-approve"
      label="Save"
    />
  )

  const progress_state = {
    // ['plan_submit_approve_reject_type_Not Planned']: <></>,
    ['plan_submit_approve_reject_type_planned']: SubmitComponent,
    ['plan_submit_approve_reject_type_submitted']: RejectApproveComponent,
    ['plan_submit_approve_reject_type_rejected']: SubmitComponent,
    ['plan_submit_approve_reject_type_approved']: <></>,

    ['plan_start_finish_type_not_planned']: <></>,
    ['plan_inprogress_done_type_planned']: InProgressDoneComponent,
    ['plan_inprogress_done_type_in_progress']: DoneComponent,
    ['plan_start_finish_type_finished']: <></>,

    ['plan_pass_fail_type_not_start']: <></>,
    ['plan_pass_fail_type_planned']: PassFailComponent,
    ['plan_pass_fail_type_pass']: <></>,
    ['plan_pass_fail_type_fail']: <></>,
    ['percentage_progress_type_planned']: SaveComponent,
    ['plan_done_type_Planned Start']: <></>,
  }

  if (current_status === 'new') return <></>

  return (
    <div className="action-field-container">
      <Row wrap={false}>
        {type === 'percentage_progress_type' ? (
          `${type}_${current_status}` === 'percentage_progress_type_100' ? (
            <></>
          ) : (
            SaveComponent
          )
        ) : (
          get(
            progress_state,
            `${type}_${value}`,
            get(progress_state, `${type}_${current_status}`, <></>)
          )
        )}
      </Row>
    </div>
  )
}
